import { render, staticRenderFns } from "./certification.vue?vue&type=template&id=584cea26&scoped=true"
import script from "./certification.vue?vue&type=script&lang=js"
export * from "./certification.vue?vue&type=script&lang=js"
import style0 from "./certification.vue?vue&type=style&index=0&id=584cea26&prod&lang=scss&scoped=true"
import style1 from "./certification.vue?vue&type=style&index=1&id=584cea26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584cea26",
  null
  
)

export default component.exports